"use client";
import * as React from "react";
const SvgHomeRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.259 13.16V8.955h3.478v4.203c0 .463.392.841.87.841h2.608c.479 0 .87-.378.87-.84V7.274h1.478c.4 0 .591-.479.287-.731L8.58.214a.899.899 0 0 0-1.165 0L.146 6.544c-.296.252-.113.731.287.731H1.91v5.884c0 .463.391.841.87.841h2.608c.479 0 .87-.378.87-.84Z" }));
export {
  SvgHomeRound as default
};
